export default __webpack_public_path__ + "static/media/hero3.a31a5a76.png";